import { render, staticRenderFns } from "./mproductlist.vue?vue&type=template&id=6f9443f5&scoped=true"
import script from "./mproductlist.vue?vue&type=script&lang=js"
export * from "./mproductlist.vue?vue&type=script&lang=js"
import style0 from "./mproductlist.vue?vue&type=style&index=0&id=6f9443f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9443f5",
  null
  
)

export default component.exports